import { render, staticRenderFns } from "./OfferControls.vue?vue&type=template&id=336e15c0&scoped=true&"
import script from "./OfferControls.vue?vue&type=script&lang=js&"
export * from "./OfferControls.vue?vue&type=script&lang=js&"
import style0 from "./OfferControls.vue?vue&type=style&index=0&id=336e15c0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "336e15c0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
